<template>
  <div class="InterDiary">
    <div style="display: inline-flex;justify-content: space-between;width: 100%;">
      <SearchForm :fields="searchFields" @submit="serach">
        <a-input-group compact>
          <a-select style="display: inline-flex;height: 30px;width: auto;" :placeholder="$t('applied_应用名称')" v-model="selectedMethods" @change="selectChange">
            <a-select-option :value="1">{{$t('applied_应用名称')}}</a-select-option>
            <a-select-option :value="2">{{$t('InterDiary_方法名')}}</a-select-option>
          </a-select>
          <a-input style="width: 200px;margin-right: 8px;" :placeholder="$t('authority_请输入')" v-model="searchForm.interFaceName" v-if="selectedMethods === 2" @change="e => textChange(e, 'interFaceName')"></a-input>
          <a-input style="width: 200px;margin-right: 8px;" :placeholder="$t('authority_请输入')" v-model="searchForm.appLicationName" v-else @change="e => textChange(e, 'appLicationName')"></a-input>
        </a-input-group>
      </SearchForm>
      <content-title style="width: 100px;">
        <template v-slot:other>
          <div style="display: flex;color: rgba(0, 0, 0, 0.45);top: 1px;">
            <div class="refresh"
              v-tooltip="{
              content: `<div>${$t('common_刷新')}</div>`,
              html: true,
              placement: 'bottom'
            }"
            >
              <a-icon type="reload" @click="$refs.smartTable.fetch()" style="font-size: 14px;" />
            </div>
          </div>
        </template>
      </content-title>
    </div>
    <div class="list-content" v-primission="'OPEN_API_LOG_VIEW'">
      <smart-table
        ref="smartTable"
        :base-url="baseURL"
        :api-path="apiPath"
        :param="param"
        :columns="columns"
        :bordered="false"
        :row-key="(record, index) => index"
        :scroll="{ y: 600 }"
      >
        <template slot="num" slot-scope="text, record, index">
          <span>{{(($refs.smartTable.pagination.current - 1) * $refs.smartTable.pagination.pageSize) + (index + 1)}}</span>
        </template>
        <template slot="requestTime" slot-scope="text, record">
          <span v-if="record.requestTime">{{moment(record.requestTime).format('YYYY-MM-DD HH:mm:ss')}}</span>
          <span v-else>{{$t('common_conj_nothing')}}</span>
        </template>
        <template slot="do" slot-scope="text, record">
          <span class="inter-diary__edit" @click="editBtn(record)">{{$t('common_btn_view_details')}}</span>
        </template>
      </smart-table>
    </div>
    <a-modal
      v-model="visible"
      :title="$t('InterDiary_参数详情')"
      :footer="null"
      @ok="visible = false"
    >
      <p>{{paramsDetail}}</p>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'
import SmartTable from '@/components/SmartTable_next'
import SearchForm from '@/components/SearchForm'
import { QueryDetail } from '@/api/login'
import api from '@/api/index'
import ContentTitle from '@/components/ContentTitle.vue'
import { mapState } from 'vuex'
export default {
  name: 'InterDiary',
  data () {
    return {
      baseURL: '',
      apiPath: api.InterfacequeryList,
      param: {},
      loading: false,
      isTips: false,
      uesrName: '',
      dateList: [],
      searchForm: {
        appLicationName: '',
        interFaceName: ''
      },
      interFaceArray: [],
      paramsDetail: '',
      visible: false,
      selectedMethods: 1,
      columns: [
        { title: 'No.', key: 'num', dataIndex: 'num', scopedSlots: { customRender: 'num' }, align: 'left', width: 90 },
        { title: this.$t('InterDiary_应用名称'), key: 'appName', dataIndex: 'appName', align: 'left', width: 170 },
        { title: this.$t('InterDiary_方法名'), key: 'interfaceMethod', dataIndex: 'interfaceMethod', scopedSlots: { customRender: 'interfaceMethod' }, align: 'left', wdith: 140 },
        { title: this.$t('InterDiary_请求时间'), key: 'requestTime', dataIndex: 'requestTime', scopedSlots: { customRender: 'requestTime' }, align: 'left', wdith: 120 },
        { title: this.$t('common_btn_handle'), key: 'do', dataIndex: 'do', scopedSlots: { customRender: 'do' }, align: 'left', width: 160 }
      ],
      replaceFields: {
        children: 'child',
        title: 'name'
      }
    }
  },
  components: {
    // VDistpicker
    SmartTable,
    ContentTitle,
    SearchForm
  },
  computed: {
    ...mapState({
      currentLang: state => state.isLogin.lang,
      'meunList': state => state.isLogin.meunList
    }),
    searchFields () {
      return [
        {
          type: 'range-picker',
          name: 'dateList',
          placeholder: [this.$t('InterDiary_开始时间'), this.$t('InterDiary_结束时间')]
        }
      ]
    }
  },
  mounted () {
    this.$refs.smartTable.fetch()
    console.log(this.$refs.smartTable)
  },
  methods: {
    moment,
    editBtn (item) {
      this.visible = true
      QueryDetail({ id: item.id }).then(({ data }) => {
        this.paramsDetail = `${data.requestParam || ''}:${data.resultData || ''}`
      })
    },
    selectChange (val) {
      if (this.selectedMethods === 1) {
        this.searchForm.interFaceName = undefined
      } else {
        this.searchForm.appLicationName = undefined
      }
    },
    serach (val) {
      let param = {
        startTime: val?.dateList ? val?.dateList?.length !== 0 ? val?.dateList[0] : '' : undefined,
        endTime: val?.dateList ? val?.dateList?.length !== 0 ? val?.dateList[1] : '' : undefined,
        interfaceMethod: this.searchForm.interFaceName || undefined,
        appName: this.searchForm.appLicationName || undefined,
        pageNum: 1
      }
      if (moment(param.endTime).diff(moment(param.startTime), 'days') > 90) {
        return this.$message.warning(this.$t('InterDiary_time_tips'))
      }
      this.param = { ...param }
    },
    onPageChange (current) {
      this.current = current
    },
    textChange (e, name) {
      if (this.searchForm[name]) {
        this.searchForm[name] = this.searchForm[name].trim()
      }
    }
  }
}
</script>
<style lang="less" scoped>
.InterDiary {
  text-align: left;
  background-color: #fff;
  margin-top: -16px;
}
.color-upoload {
  color: #4978D6;
}
.SeachDoc_no_list {
  text-align: center;
  margin-top: 203px;
  color: #999999;
  font-size:24px;
  font-family:PingFangSC-Semibold,PingFang SC;
  font-weight:600;
}
.content-title {
  width: calc(100% - 694px);
}
/deep/ .ant-table-row .ant-table-row-cell-break-word {
  padding-top: 20px !important;
  padding-bottom: 23px !important;
}
/deep/ .ant-table-thead > tr > th, /deep/ .ant-table-tbody > tr > td{
  padding: 9px 14px !important;
  text-align: center;
  color: #555555 !important;
  font-weight:400;
}
/deep/ .ant-table-thead {
  background: #F0F0F0;
}
/deep/ .ant-tooltip-inner {
  font-size: 12px;
  color: #FFFFFF;
}
.login-btn {
  margin-left: 25px;
  width:83px;
  height:32px;
  font-size: 14px;
  border-radius: 2px;
  background: #4978d6;
}
.login-bga {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.26);
  z-index: 9;
  color: #282828;
}
.login-boxs {
  width:760px;
  // height:351px;
  position: absolute;
  left: 50%;
  top:50%;
  transform:translate(-50%,-50%);
  background:rgba(255,255,255,1);
  overflow-y: auto;
  height: 600px;
}
.list-content {
  // margin-top: 45px;
  // margin-right: 24px;
}
.login-close {
  position: absolute;
  right: 29px;
  top: 17px;
  width: 19px;
  height: 32px;
}
.login-close:before, .login-close:after {
  position: absolute;
  left: 15px;
  content: ' ';
  height: 20px;
  width: 2px;
  background-color: #999999;
}
.login-close:before {
  transform: rotate(45deg);
}
.login-close:after {
  transform: rotate(-45deg);
}
.inter-diary__edit {
  color: #4978d6;
  cursor: pointer;
}
.top-t {
  padding: 14px 20px;
  font-size: 16px;
  border-bottom: 1px solid #eee;
  position: relative;
  font-weight: 400;
}
.info {
  margin-top: 15px;
  font-weight: 600;
  margin-bottom: 15px;
}
.known {
  font-size:12px;
 i {
   color: #E02020;
 }
}
.login-text {
  width:270px;
  height:91px;
}
.login-input {
  margin-left: 25px;
  width:150px;
  height:32px;
  font-size:12px;
  color: #989898;
  /deep/ .ant-input {
    font-size: 12px;
  }
}
.refresh {
  width: 30px;
  height: 30px;
  background: #FFFFFF;
  border-radius: 2px;
  border: 1px solid #D9D9D9;
  font-size: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.refresh:hover {
  transition: 0.4s;
  border: 1px solid #80b3ff;
  color: #80b3ff;
}
/deep/ .ant-select-selection--single {
  min-width: 94px;
  width: auto;
}
.search-form /deep/.ant-form {
  display: inline-flex;
}
</style>
